export const VAULTS_MENU = [
  { path: '/vaults', label: 'v2 Vaults' },
  { path: 'https://docs.yearn.fi/getting-started/products/yvaults/v2', label: 'Docs' },
  { path: 'https://discord.gg/yearn', label: 'Support', target: '_blank' },
  { path: 'https://blog.yearn.fi/', label: 'Blog', target: '_blank' },
  {
    path: 'https://gov.yearn.fi/',
    label: 'Discourse',
    target: '_blank'
  }
]
